import { render, staticRenderFns } from "./forkLiftInfo.vue?vue&type=template&id=6bfc4d16"
import script from "./forkLiftInfo.vue?vue&type=script&lang=js"
export * from "./forkLiftInfo.vue?vue&type=script&lang=js"
import style0 from "./forkLiftInfo.vue?vue&type=style&index=0&id=6bfc4d16&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bfc4d16')) {
      api.createRecord('6bfc4d16', component.options)
    } else {
      api.reload('6bfc4d16', component.options)
    }
    module.hot.accept("./forkLiftInfo.vue?vue&type=template&id=6bfc4d16", function () {
      api.rerender('6bfc4d16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/heq/forkLiftInfo.vue"
export default component.exports